import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'
import ELEMENT from 'element-ui'
import router from '@/router'
import { clearLoginInfo } from '@/utils'
import { message } from '@/utils/resetMessage'
Vue.use(ELEMENT)
const http = axios.create({
  timeout: 1000 * 50,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})
// token过期连续次数
let exitStatus = 0

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  let token = Vue.cookie.get('token')
  token && (config.headers['Authorization'] = 'Bearer ' + Vue.cookie.get('token')) // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data.code === 'E0003') {
    // token失效
    // token失效，计数器加1，成功请求则置为0，大于1则连续两次请求失效，及失效没有成功清除本地token
    // 此时需清除其父域名下的token
    exitStatus++
    clearLoginInfo()
    if (exitStatus > 1) {
      let array = location.hostname.split('.')
      let domain = array[array.length - 2] + '.' + array[array.length - 1]
      Vue.cookie.delete('token', { domain: domain })
    }
  } else {
    exitStatus = 0
  }
  if (response.data.code === 'E0000') {
    if (!Vue.cookie.get('token')) {
      router.push({
        name: 'login'
      })
    } else {
      router.push({
        name: 'menberIntroduce'
      })
    }
    // message({
    //   message: response.data.message,
    //   type: 'error',
    //   duration: 3 * 1000
    // })
  }
  return response
}, error => {
  ELEMENT.Message({
    message: '请求错误',
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  let protocol = location.protocol
  let domain = location.hostname
  let baseUrl = protocol + '//' + domain
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/proxyApi' : baseUrl) + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  }
  return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
  var defaults = {
    't': new Date().getTime()
  }
  data = openDefultdata ? merge(defaults, data) : data

  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js